import React from 'react';
import { Platforms } from '../../../../../model/platform/Platforms';
import { useTranslation } from 'react-i18next';
import { MoodashActivePlatforms } from '../dto/IDiscoveryFilter';
import { numberFormatter } from '../../../../../utils/helpers/numberFormater';
import CardLayout from '../../../../../shared/components/card/CardLayout';

interface IDiscoveryPlatformCardProps {
    action: (platformName: MoodashActivePlatforms) => void;
    platform: Platforms;
    activePlatform: boolean;
}

const DiscoveryPlatformCard = ({ action, platform, activePlatform }: IDiscoveryPlatformCardProps) => {
    const { t } = useTranslation();
    return (
        <CardLayout classCard={`${activePlatform && 'border-primary'} mr-2 cursor-pointer`} classBody="p-0">
            <div
                onClick={() => action(platform?.name as MoodashActivePlatforms)}
                className="d-flex align-items-center justify-content-start p-2"
            >
                <img src={platform?.path} alt={platform?.name} />
                <div className="ms-2">
                    <p className={`${activePlatform && 'text-primary'} mb-0 fw-bold`} style={{ fontSize: 13 }}>
                        {platform?.name}
                    </p>
                    <p className="text-muted mb-0 fs-6">
                        {numberFormatter(platform?.totalMembers ?? 0)} {t('brand.campaign.discovery.users')}
                    </p>
                </div>
            </div>
        </CardLayout>
    );
};

export default DiscoveryPlatformCard;
